module.exports = __webpack_public_path__ + "user-placeholder.b078d57f868880df67ad09c225942c66.hashedasset.svg";